import {BaseMatchModel} from "./base-match-model";
import {EntityLinkParams} from "../../../../infrastructure/models/link/entity-link-params";

export class EntityMatchModel extends BaseMatchModel {
  params: EntityLinkParams;

  constructor(params: Object, path: String, url: String, hash: String) {
    super(params, path, url, hash);

    this.params = new EntityLinkParams(this.entityId(params), params.sportName, params.filter);
  }

  entityId(params: Object): Number {
    const entityId = params.key.split('-').last()

    return Number(entityId);
  }

  entityName(params: Object): String {
    const index: Number = params.key.lastIndexOf('-');
    const entityName: String = params.key.substr(0, index);

    return entityName
  }
}
